<template>
  <div v-if="bannerInfo && bottomImage()">
    <div :class="voucherPanelClass" :style="getBgColor">
      <button
        type="button"
        class="panel-trigger"
        aria-hidden="true"
        @click="viewMore()"
      >
        CRM 배너 여닫기
      </button>
      <div class="panel-content">
        <template v-if="bottomLink()">
          <a
            href="#"
            :target="bottomTarget()"
            @click.prevent="goDetail(bottomLink())"
          >
            <img :src="bottomImage()" :alt="bannerImgAlt" />
          </a>
        </template>
        <template v-else>
          <img :src="bottomImage()" :alt="bannerImgAlt" />
        </template>
      </div>
    </div>
    <div
      v-if="textList && textList.length"
      class="ticket-event-desc"
      aria-hidden="true"
    >
      <input id="ch-event" type="checkbox" class="event-btn" />
      <label for="ch-event">이벤트 내용을 확인하세요!</label>
      <div class="ticket-event-text">
        <p v-for="(text, index) in textList" :key="index" class="dot-text">
          <span>{{ text }}</span>
        </p>
      </div>
    </div>
  </div>
  <!--ticket-event-wrap//-->
</template>

<script>
  import IntegratedTemplate from '@/mixins/integrated-template'
  import { getFromUrl, getUiserviceBannerSingle } from '@/common/utils/request'
  import { showBillingPopup, bannerLink } from '@/common/utils/common'
  import cookie from '@/common/utils/cookie'
  import _ from 'lodash'
  import { resizeThumbnail } from '@/common/utils/image'

  export default {
    mixins: [IntegratedTemplate],
    props: {
      bannerId: {
        type: String,
      },
      bannerJsonUrl: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        bannerInfo: null,
        textList: undefined,
        url: '',
        viewMoreState: false,
      }
    },
    computed: {
      voucherPanelClass() {
        let defaultClass = 'panel voucher-panel'
        if (this.viewMoreState) defaultClass = defaultClass + ' active'
        return defaultClass
      },
      getBgColor() {
        return `background-color:${_.get(this.bannerInfo, 'band.celllist.0.bgcolor', '')}`
      },
      bannerImgAlt() {
        return _.get(
          this.bannerInfo,
          ['band', 'celllist', '0', 'title_list', '0', 'text'],
          '',
        )
      },
    },
    created() {
      let bannerData = {}
      const isNotLogin = cookie.getCredential() === 'none'
      const timeStamp = new Date().getTime()
      if (this.bannerJsonUrl !== '') {
        if (isNotLogin && this.bannerId === 'oksusu') return
        bannerData = getFromUrl({
          url: this.bannerJsonUrl + '?timeStamp=' + timeStamp,
        })
      } else {
        bannerData = getUiserviceBannerSingle({ bannerid: this.bannerId })
      }

      bannerData.then((response) => {
        this.bannerInfo = response.data
        const bottomListCount = _.get(
          this.bannerInfo,
          ['band', 'celllist'],
          [],
        ).length
        if (bottomListCount && this.bottomImage() && this.bottomText2()) {
          this.textList = this.bottomText2().split(/\r\n|\n|\r/g)
        }
      })
    },
    methods: {
      bottomText3() {
        return _.get(
          this.bannerInfo,
          ['top_list', '0', 'bottom_list', '0', 'bottom_text3'],
          0,
        )
      },
      // 구매하기 버튼
      setPurchase(productid) {
        const locationOrign =
          window.location.protocol + '//' + window.location.hostname
        showBillingPopup({
          productId: productid,
          productType: 'all',
          returnUrl: locationOrign + '/callback.html?action=ClosePopup',
          canceledUrl: locationOrign + '/callback.html?action=Cancel',
        })
      },

      bottomImage() {
        if (
          _.get(this.bannerInfo, ['band', 'celllist', '0', 'thumbnail'], '')
        ) {
          return resizeThumbnail(
            _.get(this.bannerInfo, ['band', 'celllist', '0', 'thumbnail'], ''),
            { width: 0, height: 0, option: 20, quality: 80 },
          )
        }
      },
      bottomLink() {
        return _.get(
          this.bannerInfo,
          ['band', 'celllist', '0', 'event_list', '1', 'url'],
          '',
        )
      },
      bottomTarget() {
        let link = _.get(
          this.bannerInfo,
          ['band', 'celllist', '0', 'event_list', '1', 'url'],
          '',
        )
        if (link.indexOf('www.wavve.com') >= 0) return '_self'
        else if (link.indexOf('www.wavve.com') >= 0) return '_blank'
        return '_blank'
      },
      goDetail(url) {
        bannerLink(url)
      },
      viewMore() {
        this.viewMoreState = !this.viewMoreState
      },
    },
  }
</script>
